import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import connect from 'react-redux/lib/connect/connect';
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { dateFormats } from '../../../../../constants';
import { apiKeyActions } from '../../../../../state/modules/api-key';
import { ConfirmationModal, Icon } from '../../../../components';


const WelcomMessage = () => (
  <div>
    <h2>API keys</h2>
    <p>Here you can get a Caddie API key to integrate with other products</p>
  </div>
)

const ApiKeyTable = ({ keys, onDelete, onConfirmDelete, onResetDelete, keyToDelete }) => (
  keys.length > 0 ?
    <div id="api-key-table">
      <table>
        <thead>
          <tr>
            <td>Date Created</td>
            <td>Email</td>
            <td>Api Key</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {
            fp.map(
              ({ email, apiKey: { id, key, keyType, metaData: { dateCreated } } }) => (
                <tr key={key}>
                  <td>{dateFnsCompat.format(dateFnsCompat.parse(dateCreated), dateFormats.ShortDateTime)}</td>
                  <td>{email}</td>
                  <td>{key}</td>
                  <td>
                    <ConfirmationModal
                      id="confirm-delete-key"
                      key={`delete-${key}`}
                      show={keyToDelete && id === keyToDelete.id}
                      actions={[{
                        onConfirmAction: onConfirmDelete,
                        actionLabel: 'Delete',
                      }]}
                      cancel={onResetDelete}
                      message={
                        <span>
                          You are about to delete <b>{key}</b>.
                          &nbsp;
                          Any access throught this key will be deactivated.
                        </span>
                      }
                      headingText={<span>Delete Api Key</span>}
                      confirmLabel={'Delete'} />
                    <Button bsStyle='plain' className='warning' onClick={() => onDelete(id, keyType)}><Icon icon='delete-medium' />Delete</Button>
                  </td>
                </tr>
              )
            )(keys)
          }
        </tbody>
      </table>
    </div> :
    null
)

const Integration = ({
  generateApiKey,
  ...props
}) => (
    <div>
      {
        props.keys.length > 0 ?
          <Row key="api-key-table" className="no-gutter">
            <Col xs={3}>
              <h2>Your current API keys</h2>
            </Col>
            <Col xs={9}>
              <ApiKeyTable {...props} />
            </Col>
          </Row> : <WelcomMessage key="welcome-message" />
      }
      <Button key="generate-key-button" className="pull-right" onClick={generateApiKey}>Generate API key</Button>
    </div>
  )

export const KeyType = {
  Individual: 'individual',
  Business: 'business'
}

const mapStateToProps = ({ apiKey }) => ({
  keys: fp.sortBy(({
    apiKey: {
      metaData: {
        dateCreated
      }
    }
  }) => new Date() - Date.parse(dateCreated))(apiKey.keys)
})

const mapDispatchToProps = (dispatch, { type }) => ({
  generateApiKey: bindActionCreators(type === KeyType.Individual ? apiKeyActions.apiKey.generateKey : apiKeyActions.apiKey.generateBusinessKey, dispatch),
  getKeys: bindActionCreators(type === KeyType.Individual ? apiKeyActions.apiKey.getKeys : apiKeyActions.apiKey.getBusinessKeys, dispatch),
  onDeleteKey: bindActionCreators(apiKeyActions.apiKey.deleteKey, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.getKeys()
    }
  }),
  withStateHandlers(
    {
      keyToDelete: undefined
    },
    {
      onDelete: () => (id, keyType) => ({
        keyToDelete: {
          id,
          keyType
        }
      }),
      onResetDelete: () => () => ({
        keyToDelete: undefined
      })
    }
  ),
  withHandlers({
    onConfirmDelete: ({ keyToDelete, onDeleteKey, onResetDelete }) => () => {
      onDeleteKey(keyToDelete)
      onResetDelete()
    },
  })
)(Integration);


// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/integration.js